// Getting all values
$(document).ready(function(){

  $('.qzop_variant_block').click(function(){
    $(this).closest('.qz_offer_product_outer').find('.qzop_variant_block').removeClass('active');
    $(this).addClass('active');
    var currentId = $(this).attr('data-id');
    console.log(currentId);
    $(this).closest('.qz_offer_product_outer').find('.qzop_pricing').hide();
    $(this).closest('.qz_offer_product_outer').find('.qzop_pricing[data-id="'+currentId+'"]').show();

    $(this).closest('.qz_offer_product_outer').find('.main_Variant_image__Js').hide();
    $(this).closest('.qz_offer_product_outer').find('.main_Variant_image__Js[data-id="'+currentId+'"]').show();
  });


  
  function getValuesFromUrl(){
    var url = String(window.location.href);
    var urlParameters = url.split('?');
    urlParameters = String(urlParameters[1]);
    // console.log(urlParameters, 'parametrai');



    var allParameters = urlParameters.split('/');
    // console.log(allParameters);

    var sex = allParameters[0];
    var years = allParameters[1];
    var weightKg = allParameters[2];
    var weightLbs = allParameters[3];
    var heightCm = allParameters[4];
    var heightFt = allParameters[5];
    var heightIn = allParameters[6];
  
    var weigthMea = allParameters[7];
    var heigthMea = allParameters[8];

    var weightInKilos = '';
    var heightInCm = '';
    var endWeight = '';
    // console.log(sex, '--' , years, '--' , weightKg, '--' , weightLbs, '--' , heightCm, '--' , heightFt, '--' , heightIn, '--' , weigthMea, '--' , heigthMea, 'LISTING');


    $('.qz_offer_product_outer').hide();
    $('.qzop_title').hide();
    
    if (sex == 'male'){
      $('.qz_image_timeline').hide();
      $('.qz_image_timeline[data="men"]').show();
      $('.qzop_title[data="male"]').show();
      $('.qz_offer_product_outer[data="male"]').show();
    }
    else if ( sex == 'female'){
      $('.qz_image_timeline').hide();
      $('.qz_image_timeline[data="women"]').show();
      $('.qzop_title[data="female"]').show();
      $('.qz_offer_product_outer[data="female"]').show();
    }
    
  }

  getValuesFromUrl();


  $('.qz_primary_btn').click(function(evt){
    evt.preventDefault();
    if ($(this).hasClass('atc_main_btn')){
      var dataId = $(this).closest('.qz_offer_product_outer').find('.qzop_variant_block.active').attr('data-id');
      var items = [];
      items.push({ id: dataId, quantity: 1 });

      console.log(items)
  
      // First, clear the cart
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function() {
          // After the cart is cleared, add the new item
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              items: items,
            },
            dataType: "json",
            success: function (data) {
              window.location.href = '/cart';
            },
          });
        }
      });
    }
    else{
      $('html, body').animate({
          scrollTop: $(".qz_offer_product_outer").offset().top
      }, 500);
    }
    
  });
});

